import { useState, MouseEvent, useRef } from "react";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useProductCatalogContext } from "../ProductCatalogContext";
import { CompanyTypeFilterOptions } from "../../../components/filters/CompanyType/components/CompanyTypeFilterOptions";
import { DEFAULT_ENTITY_TYPE_FILTER_VALUE } from "../../../components/filters/CompanyType/constants";
import { getCompanyTypeLabel } from "../../../components/filters/CompanyType/components/utils";

export const CompanyTypeFilterChip = () => {
  const { entityTypeFilterValue, setEntityTypeFilterValue } =
    useProductCatalogContext();

  const [companyType, setCompanyType] = useState(entityTypeFilterValue);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const chipRef = useRef<HTMLDivElement>(null);

  const handleClick = (_event: MouseEvent<HTMLDivElement>) => {
    setAnchorEl(chipRef.current);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleApplyFilter = () => {
    setEntityTypeFilterValue(companyType);
    handleClose();
  };

  const handleClearFilter = () => {
    setCompanyType(DEFAULT_ENTITY_TYPE_FILTER_VALUE);
  };

  return (
    <>
      <Chip
        id="entityTypeChip"
        data-testid="catalog-filter-company-type-chip"
        ref={chipRef}
        label={
          <Box display="flex" gap="3px">
            <Typography color="secondary">Company Type:</Typography>
            <Typography>
              {getCompanyTypeLabel(entityTypeFilterValue)}
            </Typography>
          </Box>
        }
        onClick={handleClick}
        variant="outlined"
        deleteIcon={open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        onDelete={handleClick}
      />
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disablePortal
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        slotProps={{
          paper: {
            sx: {
              mt: 1,
              p: 2,
            },
          },
        }}
      >
        <Stack onClick={(e) => e.stopPropagation()} width={340} gap={2}>
          <CompanyTypeFilterOptions
            value={companyType}
            onChange={(value) => {
              setCompanyType(value);
            }}
            noClearButton
          />
          <Box display="flex" justifyContent="space-between">
            <Button
              color="inherit"
              data-testid="catalog-filter-company-type-clear-btn"
              onClick={handleClearFilter}
            >
              Clear
            </Button>
            <Box display="flex">
              <Button color="inherit" onClick={handleClose}>
                Cancel
              </Button>
              <Button
                id="entityType-filterApplyButton"
                data-testid="catalog-filter-company-type-apply-btn"
                onClick={handleApplyFilter}
              >
                Apply
              </Button>
            </Box>
          </Box>
        </Stack>
      </Menu>
    </>
  );
};
